import { defineMessages } from 'react-intl';

export default defineMessages({
  marriottLinkingHeader: {
    id: 'accountSignin.marriottLinking.heading',
    defaultMessage: 'Link accounts',
    description: 'Primary heading for sign in page for Marriott Linking',
  },
  marriottUnlinkingHeader: {
    id: 'accountSignin.marriottUnlinking.heading',
    defaultMessage: 'Unlink accounts',
    description: 'Primary heading for sign in page for Marriott Unlinking',
  },
  marriottLinkingBody: {
    id: 'accountSignin.marriottLinking.body',
    defaultMessage:
      'Please sign in to your {sbuxRewardsTm} account to start linking.',
    description: 'Primary body for sign in page for Marriott Linking',
  },
  marriottUnlinkingBody: {
    id: 'accountSignin.marriottUnlinking.body',
    defaultMessage: 'Please sign in to unlink your accounts',
    description: 'Primary body for sign in page for Marriott Unlinking',
  },
});
